export default "__VITE_ASSET__OUBkWu_u__"